// Settings of the module (PUT /settings) with the ranges from the API contract and the Czech help texts.

export const SETTING_FIELDS = [
  { key: 'backfillDays', label: 'Historie pošty při prvním načtení', unit: 'dní', min: 1, max: 365, step: 1,
    help: 'Za kolik dní zpět se při zapojení nové schránky stáhnou zásilkové e-maily.' },
  { key: 'intervalMinutes', label: 'Interval synchronizace', unit: 'minut', min: 1, max: 1440, step: 1,
    help: 'Jak často se kontroluje nová pošta. Kratší interval znamená rychlejší aktualizace, ale víc dotazů na Gmail.' },
  { key: 'confidenceThreshold', label: 'Práh jistoty AI', unit: '0,30 až 0,99', min: 0.3, max: 0.99, step: 0.01, float: true,
    help: 'E-mail s nižší jistotou AI nepůjde do zásilky automaticky, ale do fronty „Ke kontrole“.' },
  { key: 'delayDays', label: 'Zpoždění zásilky', unit: 'dní', min: 0, max: 60, step: 1,
    help: 'Zásilka se označí jako zpožděná, když je o tolik dní po očekávaném doručení. 0 = hned po termínu.' },
  { key: 'stuckDays', label: 'Dlouho nehnutá zásilka', unit: 'dní', min: 1, max: 90, step: 1,
    help: 'Aktivní zásilka bez nové události po tuto dobu se označí jako „dlouho nehnutá“.' },
  { key: 'retentionMonths', label: 'Uchování zásilek a e-mailů', unit: 'měsíců', min: 1, max: 60, step: 1,
    help: 'Starší předměty a úryvky e-mailů se mažou. Těla e-mailů ani přílohy se neukládají vůbec.' },
  { key: 'logRetentionDays', label: 'Uchování logu zpracování', unit: 'dní', min: 7, max: 730, step: 1,
    help: 'Jak dlouho se pamatuje, které zprávy už byly zpracované (aby se nestahovaly znovu).' },
  { key: 'aiDailyLimit', label: 'Denní limit AI volání', unit: 'volání', min: 10, max: 20000, step: 1,
    help: 'Po vyčerpání zbytek e-mailů počká na další den. Chrání před nečekaně vysokou cenou.' },
];

const rangeText = (f) => `${String(f.min).replace('.', ',')} až ${String(f.max).replace('.', ',')}`;

// Returns { key: 'Czech message' } for the invalid fields; `values` hold the input text.
// `skip`: keys that are not editable right now (the ENV overrides them), they are neither validated nor sent.
export function validateSettings(values, skip = []) {
  const errors = {};
  SETTING_FIELDS.filter((f) => !skip.includes(f.key)).forEach((f) => {
    const raw = String(values[f.key] ?? '').trim().replace(',', '.');
    const n = Number(raw);
    if (raw === '' || !Number.isFinite(n)) errors[f.key] = 'Zadejte číslo.';
    else if (!f.float && !Number.isInteger(n)) errors[f.key] = 'Zadejte celé číslo.';
    else if (n < f.min || n > f.max) errors[f.key] = `Povolený rozsah je ${rangeText(f)}.`;
  });
  return errors;
}

// Czech decimal comma in the inputs ("0,7")
export const toInputValues = (settings) => Object.fromEntries(
  SETTING_FIELDS.map((f) => [f.key, settings?.[f.key] == null ? '' : String(settings[f.key]).replace('.', ',')]),
);

// Only the changed fields, as numbers
export function changedSettings(values, settings, skip = []) {
  const body = {};
  SETTING_FIELDS.filter((f) => !skip.includes(f.key)).forEach((f) => {
    const n = Number(String(values[f.key]).trim().replace(',', '.'));
    if (n !== Number(settings?.[f.key])) body[f.key] = n;
  });
  return body;
}

export { rangeText };
